import { Button, Typography } from "@material-ui/core";
import React, { Fragment, useState } from "react";
import toast from "react-hot-toast";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import { modalShow } from "../../../../../../actions";
import { TGetContractsItemValuation } from "../../../../../../api/contract/contract.types";
import TrashIcon from "../../../../../../assets/images/iconos/trash-can.png";
import cuideoTheme from "../../../../../../containers/themes/defaultTheme";
import { apiEmpleo } from "../../../../../../util/ApiEmpleo";
import {
  VALORACION_CONTRATADO,
  VALORACION_DESCARTADO,
  VALORACION_SUGGESTION,
} from "../../../../../../util/defaults/valoracion";
import { TOnContractValuationChangeFn } from "../../../contract/types/contract-valuation.types";
import { TContractValuation } from "../../types/valuation.types";
import DiscardValuationsDialog from "../DiscardValuationsDialog/DiscardValuationsDialog";

const StyledDelete = styled(Button)`
  text-transform: none;
  font-weight: 400;
  font-size: 0.75rem;
  padding: 0 0.5rem;
`;

const StyledButtonIcon = styled.img`
  margin-right: 0.5rem;
  width: 0.75rem;
  height: 0.75rem;
`;

const StyledInscritaText = styled(Typography)`
  font-size: 0.75rem;
  color: ${cuideoTheme.palette.primary.main};
`;

interface IValuationDiscardButtonProps {
  valuation: TContractValuation;
  isDisabled: boolean;
  onChange: TOnContractValuationChangeFn;
}

const ValuationDiscardButton = (props: IValuationDiscardButtonProps) => {
  const { valuation, isDisabled, onChange } = props;
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const [descartando, setDescartando] = useState(false);

  const isSuggestion = valuation.Estado_en_proceso === VALORACION_SUGGESTION;
  const candidateName = `${valuation.candidato?.Nombre} ${valuation.candidato?.Apellidos}`;

  const handleEliminar = (e: React.MouseEvent) => {
    e.stopPropagation();
    setDescartando(true);
  };

  const handleCloseDialog = () => {
    setDescartando(false);
  };

  const handleConfirm = (reason: string) => {
    const sendData = async () => {
      const data = {
        Estado_en_proceso: VALORACION_DESCARTADO,
        cuideo_discard_reason: reason,
      };
      const updatedValuation: TGetContractsItemValuation = {
        ...valuation,
        Estado_en_proceso: VALORACION_DESCARTADO,
      };

      setDescartando(false);
      // handleChange({ ...valuation, status: "mutating" });
      onChange({
        op: "update_status_start",
        updatedValuation,
        refreshAfterUpdate: false,
      });
      try {
        if (isSuggestion) {
          await apiEmpleo.patch(
            `suggestions/${valuation.id}`,
            {
              status: "rejected",
            },
            {
              headers: {
                "Content-Type": "application/merge-patch+json",
              },
            }
          );
        } else {
          await apiEmpleo.patch(`valoraciones/${valuation.id}`, data, {
            headers: {
              "Content-Type": "application/merge-patch+json",
            },
          });
          toast.success(
            formatMessage(
              {
                id: "PipelineButton.Se ha descartado la valoración de {candidato}",
                defaultMessage: "Se ha descartado la valoración de {candidato}",
              },
              { candidato: candidateName }
            )
          );
          onChange({
            op: "update_status_end",
            updatedValuation,
            refreshAfterUpdate: true,
          });
          // handleChange({ ...valoracion, status: "deleted" });
        }
      } catch (e) {
        dispatch(
          modalShow({
            open: true,
            type: "error",
            message: formatMessage({
              id: "PipelineButton.Ha habido algún error",
              defaultMessage: "Ha habido algún error",
            }),
          })
        );
      }
    };

    sendData();
  };

  return (
    <Fragment>
      {valuation.Estado_en_proceso !== VALORACION_DESCARTADO ? (
        <StyledDelete
          color="primary"
          onClick={handleEliminar}
          disabled={isDisabled}
        >
          <StyledButtonIcon src={TrashIcon} />
          {isSuggestion ? (
            <FormattedMessage
              id="ValuationCard.Rechazar sugerencia"
              defaultMessage="Rechazar sugerencia"
            />
          ) : (
            <FormattedMessage
              id="ValuationCard.Eliminar de la oferta"
              defaultMessage="Eliminar de la oferta"
            />
          )}
        </StyledDelete>
      ) : (
        <StyledInscritaText>
          <FormattedMessage
            id="DiscardButton.AlreadyDiscarded"
            defaultMessage="Ya descartada"
          />
        </StyledInscritaText>
      )}
      {/* The dialog is portaled, but React still bubbles its clicks up to the card. */}
      <span
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <DiscardValuationsDialog
          open={descartando}
          candidateNames={[candidateName]}
          reasonRequired={!isSuggestion}
          warning={
            valuation.Estado_en_proceso === VALORACION_CONTRATADO && (
              <FormattedMessage
                id="PipelineButton.Atención! Si eliminas esta candidata has de mirar si la actividad laboral de ALTA está realizada o no, y cancelarla en caso de que no esté realizada"
                defaultMessage="Atención! Si eliminas esta candidata has de mirar si la actividad laboral de ALTA está realizada o no, y cancelarla en caso de que no esté realizada"
              />
            )
          }
          onConfirm={handleConfirm}
          onCancel={handleCloseDialog}
        />
      </span>
    </Fragment>
  );
};

export default ValuationDiscardButton;
